


// import Cookies from "js-cookie";
// import { Navigate } from "react-router-dom";

// export default function ProtectedRoute({ children }) {
//   const token = Cookies.get("token");

//   if (!token) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// }


import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../app/store";

export default function ProtectedRoute({ roles }) {
  const { token, user } = useAuth();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;   // <-- THIS IS THE KEY
}



